import { useKeycloak } from "@react-keycloak/web";
import React from "react";

const LoginErrorPage = () => {
  const { keycloak } = useKeycloak();
  const logOut = () => {
    keycloak?.logout();
    localStorage.removeItem("token");
    localStorage.removeItem("id_token");
  };
  return (
    <div className="authincation h-100 p-meddle">
      <div className="container h-100">
        {" "}
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-7">
            <div
              className="form-input-content text-center error-page"
              style={{ marginTop: "30vh" }}
            >
              <h1 className="error-text font-weight-bold">HATA</h1>
              <h4>
                <i className="fa fa-thumbs-down text-danger" /> GLAS
                uygulamasına yetkiniz bulunmamaktadır.
              </h4>
              <p>
                Bir hata olduğunu düşünüyorsanız lütfen Sistem Yöneticisine
                başvurunuz.
              </p>
              <button className="btn btn-info" onClick={logOut}>
                Giriş Ekranına Dön
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginErrorPage;
